<div class="snackbar">
	<div class="snackbar__text">
		<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon"
			style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1">
			<path
				d="M512 554.666667a63.573333 63.573333 0 0 0-42.666667 111.36V725.333333a42.666667 42.666667 0 0 0 85.333334 0v-59.306666A63.573333 63.573333 0 0 0 512 554.666667z m213.333333-170.666667V298.666667A213.333333 213.333333 0 0 0 298.666667 298.666667v85.333333a128 128 0 0 0-128 128v298.666667a128 128 0 0 0 128 128h426.666666a128 128 0 0 0 128-128v-298.666667a128 128 0 0 0-128-128zM384 298.666667a128 128 0 0 1 256 0v85.333333H384z m384 512a42.666667 42.666667 0 0 1-42.666667 42.666666H298.666667a42.666667 42.666667 0 0 1-42.666667-42.666666v-298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667h426.666666a42.666667 42.666667 0 0 1 42.666667 42.666667z" />
		</svg>

		<span>{{ 'app.unlock_content' | translate }}</span>
	</div>
	<div class="snackbar__button">
		<button class="btn primary" type="button" (click)="goMembership()">
			<span class="button-text">{{ 'app.become_member' | translate }}</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'arrow-right-long']"></fa-icon>
			</span>
		</button>
	</div>
</div>